import { render } from "./RevenueReport.vue?vue&type=template&id=3c913b62&scoped=true"
import script from "./RevenueReport.vue?vue&type=script&lang=js"
export * from "./RevenueReport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c913b62"]])

export default __exports__